import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, CheckCircle2, ChevronDown } from 'lucide-react';
const testimonials = [{
  id: 1,
  author: 'Sarah M.',
  text: "I was skeptical but module 3 literally explained a recurring dream I've had for years. Worth every penny."
}, {
  id: 2,
  author: 'David R.',
  text: "Finally something that isn't just a generic dream dictionary. The framework actually makes sense and I used it the very first morning."
}, {
  id: 3,
  author: 'Jessica T.',
  text: "For $20 I figured why not. It's actually crazy how accurate this is once you know what to look for. Highly recommend."
}, {
  id: 4,
  author: 'Michael B.',
  text: "I've always had vivid dreams and never knew what to do with them. This system gave me so much clarity. The step-by-step approach is brilliant."
}, {
  id: 5,
  author: 'Amanda K.',
  text: 'Bought this on a whim at 2am. Read through the first few modules and decoded a nightmare I had last week. Mind blown.'
}, {
  id: 6,
  author: 'Chris L.',
  text: 'Simple, straight to the point, no fluff. Exactly what I was looking for.'
}];
const faqs = [{
  question: 'What exactly do I get?',
  answer: "You get instant, lifetime access to the complete 10-module Dream Decoding System. It's a digital framework you can access immediately on your phone, tablet, or computer. No waiting for shipping."
}, {
  question: 'Is this just another dream dictionary?',
  answer: 'Not at all. Dream dictionaries give you generic meanings that rarely apply to your specific life. This is a step-by-step system that teaches you how to decode your unique dreams based on your personal context and psychology.'
}, {
  question: 'How long does it take to see results?',
  answer: 'You can start decoding your dreams the very first night. The system is designed to be consumed quickly, so you can learn the framework in under an hour and apply it immediately the next time you wake up.'
}, {
  question: 'Is this backed by anything real?',
  answer: 'Yes. The system is built on established psychological principles of dream analysis and subconscious processing, stripped of the academic jargon and turned into a practical, easy-to-use framework for everyday people.'
}, {
  question: "What if it doesn't work for me?",
  answer: "We offer a 7-day money-back guarantee. If you go through the system, apply the framework, and still can't make sense of your dreams, just email us within 7 days of purchase and we'll refund your $19.99 in full. No questions asked."
}];
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-dark-border last:border-0" data-id="element-120">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none group" data-id="element-121">
        <span className="text-lg sm:text-xl font-medium text-zinc-200 group-hover:text-white transition-colors" data-id="element-122">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-zinc-500 transition-transform duration-300 ml-4 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-123" />
      </button>
      <AnimatePresence data-id="element-124">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-125">
            <p className="pb-6 text-zinc-400 leading-relaxed" data-id="element-126">
              {"We offer a 7-day money-back guarantee. If you go through the system, apply the framework, and still can't make sense of your dreams, just email us within 7 days of purchase and we'll refund."}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function SocialProof() {
  return;
}